import { useEffect, useState } from "react";
import { Translation, useTranslation } from "react-i18next";
import { logEvent } from "../../../analytics";

const RemoveQuantityButton = ({row, staticQuantityArray, sendQuantityDataFromChild}) => {
    const [quantity, setQuantity] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {
        setQuantity(staticQuantityArray);
    }, [staticQuantityArray]);

    const addQuantity = (e) => {
        e.preventDefault();
        if(row.loyalty_point < 0) {
            return;
        }
        setQuantity(parseFloat(quantity) + 1);
        sendQuantityDataFromChild({'id': row.productid, 'product':row, 'quantity':parseFloat(quantity) + 1, 'action': 'remove'});
        logEvent('create_order_page', 'cart', 'add-quantity', row.b2bline1+'-'+row.item_code+'-quantity:'+(parseFloat(quantity) + 1));
    }

    const subtractQuantity = (e) => {
        e.preventDefault();
        if(parseFloat(quantity) > 0) {
            setQuantity(parseFloat(quantity) - 1);
            sendQuantityDataFromChild({'id': row.productid, 'product':row, 'quantity': parseFloat(quantity) - 1, 'action': 'remove'});
            logEvent('create_order_page', 'cart', 'remove-quantity', row.b2bline1+'-'+row.item_code+'-quantity:'+(parseFloat(quantity) - 1));
        }
    }

    const removeItems = (e) => {
        e.preventDefault();
        sendQuantityDataFromChild({'id': row.productid, 'product': 'remove', 'quantity': 0, 'action': 'remove'});
        logEvent('create_order_page', 'cart', 'remove-proudct-to-cart', row.b2bline1+'-'+row.item_code);
    }

    const handleChange = (e) => {
        if(e.target.value >= 0) {
            setQuantity(e.target.value);
            sendQuantityDataFromChild({'id': row.productid, 'product':row, 'quantity':parseFloat(e.target.value), 'action': 'remove'});
            logEvent('create_order_page', 'cart', 'add-quantity', row.b2bline1+'-'+row.item_code+'-quantity:'+e.target.value);
        }
    }

    return (
        <>
            <div className="flex text-base bg-white border border-blue-normal rounded-lg text-blue-normal font-medium justify-between items-center">
                <div className="cursor-pointer w-full h-full flex flex-col justify-center items-center py-2 px-3" onClick={(e) => subtractQuantity(e)}>
                    <img src="../../../../assets/icons/minus.svg" alt="minus" />
                </div>
                <div className="w-16 text-center py-2">
                    <input className="focus:outline-none remove-arrow text-center w-16" type="number" value={quantity} onChange={(e) => handleChange(e)}/>
                </div>
                <div className="cursor-pointer w-full h-full flex flex-col justify-center items-center py-2 px-3" onClick={(e) => addQuantity(e)}>
                    <img src="../../../../assets/icons/plus.svg" alt="plus" />
                </div>
            </div>
            <button onClick={(e) => removeItems(e)}  className="capitalize ml-3 sm:mt-2 lg:mt-0">
                <img src="../../../../assets/icons/table/delete.svg" alt="delete" />
            </button>
        </>

    )
}

export default RemoveQuantityButton;